module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAZCAYAAAA4/K6pAAABQklEQVQ4T+2UP0sDQRTEZ86EgBqCIH4PK+tUFsY9QSRdSjEqgpWNnSBoY0RITGNxlcbGvZWAH0EI+C2SSrEShdyNxD8QgsgdWFhk25357dvHm8cgCKYKhZk6iTKAHJKdVwktz0OV1roGiXUA14B6yfycAwYPqklrw2fSuzSmtJHM/Kmy1tVIVBiGTpIO4ji6SAPwvMwaieMPQBrjqPYbcAPoPh2ICwBWvr6Aqu8vn6cBWOs2SDTGgHEP/tcc7GUyXpBmlPv9uELi6G/SKOGOxEOaCiTMk1j8NUzOuUNJsTFmfxQ+kkZu+n6pMSzqdDrZbrf3BkD5/HSuWCz2h++tddskzgYVPAFs/bQTnXNbg31njKmPVhCGYRPgKp1zNQk7AG4BPibrg2YBLEk6ZbvdzkVRdCKhTGIyCUDCi4SrbHZi9x2vLf9e83HveQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouji.png
// module id = wYZK
// module chunks = 3